<div class="card-container" #container>
    <div class="card-header-wrapper">
        <h3 class="card-title"> {{ customMsgService.translate('consumo') }} </h3>
        <span></span>
    </div>

    <div class="card-component">

        <kendo-grid [kendoGridBinding]="gridView" kendoGridSelectBy="id" [selectedKeys]="mySelection" [pageSize]="30"
            [pageable]="true" [sortable]="true" [groupable]="true"  [reorderable]="true"
            [resizable]="true" [height]="690" [columnMenu]="{ filter: true }" (filterChange)="filterChange($event)">
            <ng-template kendoGridToolbarTemplate>

                <!-- Barra de Pesquisa -->
                <kendo-textbox [placeholder]="customMsgService.translate('gridSearch')" kendoTextBox
                    style="width: 220px;" (valueChange)="onFilter($event)">
                </kendo-textbox>

                <!-- Filtro de Centro de Custo -->
                <kendo-dropdownlist kendoDropDownFilter style="width: 220px;" textField="nome"
                    [(ngModel)]="centroDeCusto" [data]="listCentroDeCusto" #tipoCentroDeCusto valueField="id"
                    [defaultItem]="placeHolder">
                </kendo-dropdownlist>

                <!-- Data De: -->
                <form class="k-form k-form-horizontal"
                    style="max-width: 200px;width: 200px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataDe" [text]="customMsgService.translate('de')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataDe" #dataDe></kendo-datepicker>
                    </kendo-formfield>
                </form>

                <!-- Data Ate: -->
                <form class="k-form k-form-horizontal"
                    style="max-width: 250px;width: 250px; display: flex; justify-content: space-between;"
                    [formGroup]="formGroup">
                    <kendo-formfield orientation="horizontal">
                        <kendo-label class="k-label" [for]="dataAte" [text]="customMsgService.translate('ate')">
                        </kendo-label>
                        <kendo-datepicker formControlName="dataAte" #dataAte></kendo-datepicker>
                    </kendo-formfield>
                </form>

                <!-- Botão Filtrar -->
                <button kendoButton (click)="pesquisar()" themeColor="primary">
                    {{customMsgService.translate('filtrar')}} </button>

                <kendo-grid-spacer></kendo-grid-spacer>

                <!-- Botão exportar Excel -->
                <button kendoGridExcelCommand type="button" [title]="customMsgService.translate('btnExportarExcel')"
                    icon="file-excel" themeColor="warning">
                </button>

                <!-- Botão exportar PDF -->
                <button kendoGridPDFCommand icon="file-pdf" [title]="customMsgService.translate('btnExportarPDF')"
                    themeColor="warning"> </button>
            </ng-template>

            <!-- Centro de Custo -->
            <kendo-grid-column field="nomeCentroDeCusto" [title]="customMsgService.translate('centroDeCusto')"
                [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('name')}}: {{dataItem.nomeCentroDeCusto}}">
                        <div class="customer-name"> {{ dataItem.nomeCentroDeCusto }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <!-- Artigo -->
            <kendo-grid-column field="nomeArtigo" [title]="customMsgService.translate('artigo')" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span kendoTooltip title="{{customMsgService.translate('name')}}: {{dataItem.nomeArtigo}}
{{customMsgService.translate('codigoInterno')}}: {{dataItem.codigoInterno}}
{{customMsgService.translate('codigoFabricante')}}: {{dataItem.codigoFabricante}}">
                        <div class="customer-name"> {{ dataItem.nomeArtigo }} </div>
                    </span>
                </ng-template>
            </kendo-grid-column>

            <!-- Quantidade -->
            <kendo-grid-column field="quantidade" [title]="customMsgService.translate('quantidade')" [width]="75">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="customer-name"> {{ dataItem.quantidade }} </div>
                </ng-template>
            </kendo-grid-column>

            <!-- PDF -->
            <kendo-grid-pdf fileName="{{customMsgService.translate('consumo')}}.pdf" [repeatHeaders]="true"
                [allPages]="true" paperSize="A4" [landscape]="true" [scale]="0.6">
                <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
                <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
                    <div class="page-template">
                        <div class="header">
                            <div style="float: left">
                                {{ customMsgService.translate('consumo') }}
                            </div>
                        </div>
                        <div class="footer">{{ customMsgService.translate('pagina') }} {{ pageNum }} {{
                            customMsgService.translate('de_') }} {{ totalPages }}</div>
                    </div>
                </ng-template>


                <kendo-grid-column field="nomeCentroDeCusto" [title]="customMsgService.translate('centroDeCusto')">
                </kendo-grid-column>

                <kendo-grid-column field="nomeArtigo" [title]="customMsgService.translate('artigo')">
                </kendo-grid-column>

                <kendo-grid-column field="quantidade" [title]="customMsgService.translate('quantidade')">
                </kendo-grid-column>

            </kendo-grid-pdf>

            <!-- Excel -->
            <kendo-grid-excel [fetchData]="allData" fileName="{{customMsgService.translate('movimentos')}}.xlsx">
            </kendo-grid-excel>

        </kendo-grid>
    </div>
</div>
<div kendoDialogContainer></div>